import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import TimeoutInattivita from './components/TimeoutInattivita';
import InformativaPrivacy from './components/InformativaPrivacy';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ClientiPage from './pages/ClientiPage';
import InterventiPage from './pages/InterventiPage';
import FatturePage from './pages/FatturePage';
import DdtPage from './pages/DdtPage';
import PreventiviPage from './pages/PreventiviPage';
import MagazzinoPage from './pages/MagazzinoPage';
import ImpostazioniPage from './pages/ImpostazioniPage';
import CollegaClientiFic from './pages/CollegaClientiFic';
import EmailPage from './pages/EmailPage';
import FlottaPage from './pages/FlottaPage';
import QuindicizzaPage from './pages/QuindicizzaPage';
import ContrattiPage from './pages/ContrattiPage';
import ClienteDettaglio from './pages/ClienteDettaglio';
import LogPage from './pages/LogPage';
import TvDashboard from './pages/TvDashboard';
import MappaClientiPage from './pages/MappaClientiPage';
import InterventoDettaglio from './pages/InterventoDettaglio';
import NuovoIntervento from './pages/NuovoIntervento';
import PromemoriaPage from './pages/PromemoriaPage';
import ConvertiPreventiviPage from './pages/ConvertiPreventiviPage';
import { PromemoriaProvider } from './promemoria/PromemoriaContext';
import './index.css';

const Placeholder = ({ title }) => (
  <div className="page-content">
    <div className="card" style={{ textAlign:'center', padding:48 }}>
      <div style={{ fontSize:48, marginBottom:16 }}>🚧</div>
      <h2 style={{ color:'#1f2937', marginBottom:8 }}>{title}</h2>
      <p style={{ color:'#9ca3af' }}>Modulo in sviluppo</p>
    </div>
  </div>
);

function AppLayout() {
  const location = useLocation();
  const { user } = useAuth();
  const puoDashboard = ['admin','segreteria'].includes((user?.ruolo || '').toLowerCase());
  const homePath = puoDashboard ? '/' : '/interventi';
  const puoClienti = ['admin','segreteria'].includes((user?.ruolo || '').toLowerCase());
  const puoPromemoria = ['admin','segreteria'].includes((user?.ruolo || '').toLowerCase());
  const titles = {
    '/':             'Dashboard',
    '/clienti':      'Gestione Clienti',
    '/interventi':   'Interventi',
    '/contratti':    'Contratti',
    '/preventivi':   'Preventivi',
    '/fatture':      'Fatture FIC',
    '/ddt':          'DDT',
    '/magazzino':    'Magazzino FIC',
    '/mappa':        'Mappa Clienti',
    '/impostazioni': 'Impostazioni',
    '/promemoria':   'Promemoria',
    '/converti-preventivi': 'Converti Preventivi in DDT',
  };
  const title = titles[location.pathname] || 'Quindi';

  return (
    <div className="app-shell">
      <TimeoutInattivita />
      <InformativaPrivacy />
      <Sidebar />
      <div className="main-content">
        <div className="topbar">
          <h2>{title}</h2>
        </div>
        <PromemoriaProvider attivo={puoPromemoria}>
        <Routes>
          <Route path="/" element={puoDashboard ? <Dashboard /> : <Navigate to="/interventi" replace />} />
          <Route path="/clienti" element={puoClienti ? <ClientiPage /> : <Navigate to={homePath} replace />} />
          <Route path="/mappa-clienti" element={<MappaClientiPage />} />
          <Route path="/clienti/:id" element={puoClienti ? <ClienteDettaglio /> : <Navigate to={homePath} replace />} />
          <Route path="/interventi/nuovo" element={<NuovoIntervento />} />
          <Route path="/interventi/:id" element={<InterventoDettaglio />} />
          <Route path="/interventi"   element={<InterventiPage />} />
          <Route path="/fatture"      element={<FatturePage />} />
          <Route path="/ddt"          element={<DdtPage />} />
          <Route path="/preventivi"   element={<PreventiviPage />} />
          <Route path="/magazzino"    element={<MagazzinoPage />} />
          <Route path="/contratti"    element={<ContrattiPage />} />
          <Route path="/contratti/:id" element={<ContrattiPage />} />
          <Route path="/mappa"        element={<MappaClientiPage />} />
          <Route path="/impostazioni" element={<ImpostazioniPage />} />
          <Route path="/log"          element={<LogPage />} />
          <Route path="/collega-clienti" element={<CollegaClientiFic />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/flotta" element={<FlottaPage />} />
          <Route path="/quindicizza" element={<QuindicizzaPage />} />
          <Route path="/converti-preventivi" element={
            puoPromemoria ? <ConvertiPreventiviPage /> : <Navigate to={homePath} replace />} />
          <Route path="/promemoria" element={
            puoPromemoria ? <PromemoriaPage /> : <Navigate to={homePath} replace />} />
          <Route path="*" element={<Navigate to={homePath} replace />} />
        </Routes>
        </PromemoriaProvider>
      </div>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner"></div></div>;
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          
        <Route path="/tv/:token" element={<TvDashboard />} /><Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={
            <PrivateRoute><AppLayout /></PrivateRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
